import { Grid } from '@material-ui/core';
import React, { useState } from 'react';

import { ModelSecondaryButton } from '~/src/dash/components/model-secondary-button';
import { Text, TextInput, usePublicaTranslation } from '~/src/dash/publicaUI';

interface IMinMaxEditor {
  min: number;
  max: number;
  handleOnChangeMinMax: (value: string, name: string) => void;
  onClear: () => void;
  minLimit: number;
  maxLimit: number;
}

const MinMaxEditor = ({
  min,
  max,
  minLimit = 0,
  maxLimit,
  handleOnChangeMinMax,
  onClear,
}: IMinMaxEditor) => {
  const { t } = usePublicaTranslation();
  const [reactKey, setReactKey] = useState(0);

  return (
    <Grid container direction='row' alignItems='center' spacing={2}>
      <Grid item xs={2}>
        <Text extraSmall tKey='Min' />
        <TextInput
          key={reactKey}
          type='number'
          width='100px'
          placeholder='0s'
          msDelay={500}
          initialValue={min <= minLimit || min > max ? '' : String(min)}
          handleOnChange={(value) => {
            handleOnChangeMinMax(value, 'Min');
            setReactKey((value) => value + 1);
          }}
        />
      </Grid>
      <Grid item />
      <Grid item xs={2}>
        <Text extraSmall tKey='Max' />
        <TextInput
          key={reactKey}
          type='number'
          width='100px'
          placeholder={t('NoMax')}
          msDelay={500}
          initialValue={max >= maxLimit ? '' : String(max)}
          handleOnChange={(value) => {
            handleOnChangeMinMax(value, 'Max');
            setReactKey((value) => value + 1);
          }}
        />
      </Grid>
      <Grid item xs={3}>
        <ModelSecondaryButton
          style={{
            marginLeft: '10px',
            marginTop: '35px',
            marginBottom: '10px',
          }}
          onClick={() => {
            onClear();
            setReactKey((value) => value + 1);
          }}
        >
          {t('Clear')}
        </ModelSecondaryButton>
      </Grid>
    </Grid>
  );
};

export default MinMaxEditor;
